import React, { useEffect } from "react";
import { supabase } from "../../supabase";

export default function AuthCallback() {
  useEffect(() => {
    checkUserAndRedirect();
  }, []);

  const checkUserAndRedirect = async () => {
    try {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) {
        window.location.href = "/";
        return;
      }

      // Check if user has completed onboarding; new users go to /onboarding
      const { data: profile } = await supabase
        .from("user_profiles")
        .select("profile_complete")
        .eq("user_id", user.id)
        .single();

      if (profile?.profile_complete) {
        window.location.href = "/explore";
      } else {
        window.location.href = "/onboarding";
      }
    } catch (error) {
      console.error("Auth callback error:", error);
      window.location.href = "/";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        backgroundColor: "#fafafa",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            fontSize: "18px",
            color: "#525252",
            marginBottom: "1rem",
          }}
        >
          Completing sign in...
        </div>
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "3px solid #e5e5e5",
            borderTop: "3px solid #1a1a1a",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto",
          }}
        />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}
